import styled from 'styled-components';

export const Container = styled.button`
  width: 100%;
  text-align: center;
  border: 0;
  border-radius: 8px;
  box-shadow: 0 0 10px var(--shadow-color);
  background-color: var(--main-color);
  color: var(--text-color-1);
  font-size: 2rem;
  letter-spacing: 1px;
  font-weight: 500;
`;
